import { render, staticRenderFns } from "./TooltipText.vue?vue&type=template&id=514e8748&scoped=true&"
import script from "./TooltipText.vue?vue&type=script&lang=ts&"
export * from "./TooltipText.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipText.vue?vue&type=style&index=0&id=514e8748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514e8748",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
